@use '@design/design-tokens/typography/typography' as *;
@use '@terminal/components/tooltip-container/shared-tooltip-styles' as *;

.tableLoaderWrapper {
  height: 100%;
}

.errorMessageWrapper {
  border: none;
}

.cellWithTooltip {
  &.hasTooltip {
    @include underline-text-styles;
  }
}

.overflowEllipsisTextCell {
  overflow-x: hidden;
  text-overflow: ellipsis;
  padding-bottom: 3px;
  margin-bottom: -3px;
  font-family: var(--font-nort);

  &.hasTooltip {
    @include underline-text-styles;
  }
}

.logoAndTickerWrapper {
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: flex-start;
  align-items: center;
}

.underlinedTextWrapper {
  @include underline-text-styles;
}

.styledListWrapper {
  padding-left: 20px;
}

.textualTextWrapper {
  @include typography-v2-body-sm;

  font-family: var(--font-nort);
}
